// Copyright (c) 2021, Elicenciamento. All rights reserved.

import elicenciamento from "./themes/elicenciamento";

const themes = {
  elicenciamento,
};

const variants = {
  get: (key) => themes[key],
  keys: Object.keys(themes),
  default: "elicenciamento",
};

export default variants;
